<div id="m-5">
  <div class="h-100">
    <div class="page-content">
      <div class="container-fluid">

        <div class="row center align-items-start justify-content-evenly">
          <div class="col-md-4">
            <div class="pb-3 mb-5">
              <a [routerLink]="['/']" routerLinkActive="router-link-active"> <img class="logo-img" style="width: 200px;"
                  src="assets/img/logo.png" alt=""></a>
            </div>
            <div class="">
              <h2 class="dark fs-30 fw-bold">School Billing And Payment System</h2><br>
              <p class="dark">School Billing made easy. Remove friction from managing all <br
                  class="d-lg-inline d-md-none d-none"> academic payment processes, end-to-end</p><br>

              <!-- <button routerLink="/auth/voucher"
                              class="font-weight-medium btn cs-red shadow-lg px-4 py-2 mb-5 buy-voucher"> Apply online
                              <img src="assets/img/arrow-right.png" alt=""> </button> -->
            </div>
          </div>
          <div class="col-md-7">
            <div class="card">
              <div class="card-body">
                <form style="margin-top: -20px" role="form" method="Post" #registerForm="ngForm" (ngSubmit)="submit()">
                  <aw-wizard class="aw-wizard-step-container">
                    <aw-wizard-step stepTitle="Profile Info" class="p-4">
                      <label class="control-label dark" for="lastName" translate>Student Image (Max: 2.5mb)<span
                          style="color: red;">*</span></label>
                      <input type="file"  accept="image/*" class="form-control" (change)="onFileSelected($event)">&nbsp;
                      <div class="row">
                        <div class="col-md-3">

                        </div>
                        <div class="col-md-6">
                          <div *ngIf="previewUrl">
                            <label class="control-label dark" for="lastName" translate>Image Preview</label>&nbsp;
                            <img [src]="previewUrl" alt="Image Preview" style="max-width: 200px;max-height: 200px">
                          </div>
                        </div>
                        <div class="col-md-3">

                        </div>
                      </div>
                      &nbsp;
                      <!-- <button (click)="onUpload()">Upload</button> -->
                      <!-- <div class="group-gap">

                                    
                                    <div class="avatar-upload">
                                      <div class="avatar-edit">
                                        <input type='file' id="imageUpload" accept=".png, .jpg, .jpeg" #fileInput (change)="uploadFile($event)" />
                                      </div>
                                      <div class="avatar-preview">
                                        <div id="imagePreview" [style.backgroundImage]="'url('+ imageUrl +')'">
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                          
                                   
                                    <button type="submit" class="btn btn-danger btn-lg btn-block" (click)="fileInput.click()">Upload Image</button> -->


                      <div class="row">
                        <!-- <div class="mb-3 form-group col-md-12">
                          <label class="control-label dark" for="lastName" translate>Title <span
                              style="color: red;">*</span></label>
                          <div class="input-group">
                            <ng-select class="input-group w-100" placeholder="Choose Title..." aria-hidden="true"
                              [(ngModel)]="reg.title" name="title">
                              <ng-option [value]="'Mr'">Mr</ng-option>
                              <ng-option [value]="'Mrs'">Mrs</ng-option>
                              <ng-option [value]="'Miss'">Miss</ng-option>
                            </ng-select>
                          </div>
                        </div> -->
                        <div class="mb-3 form-group col-md-6">
                          <label class="control-label dark" for="lastName" translate>Surname <span
                              style="color: red;">*</span></label>
                          <input type="text" class="form-control" [(ngModel)]="reg.lastName" name="lastName"
                            placeholder="{{'Surname ' | translate }}" required>
                        </div>
                        <div class="mb-3 form-group col-md-6">
                          <label class="control-label dark" for="firstName" translate>Other Name(s) <span
                              style="color: red;">*</span></label>
                          <input type="text" class="form-control" [(ngModel)]="reg.firstName" name="firstName"
                            placeholder="{{'Other Name(s) ' | translate }}" required>
                        </div>
                        <div class="form-group col-md-12">
                          <label class="control-label dark" for="dateOfBirth" translate>Date of Birth <span
                              style="color: red;">*</span></label>
                          <input type="date" class="form-control" [(ngModel)]="reg.dateOfBirth" name="dateOfBirth"
                            placeholder="{{'DOB' | translate }}" required>
                        </div>
                        <!-- <div class="mb-3 form-group col-md-6">
                                      <label class="control-label dark" for="age" translate>Age</label>
                                      <input type="number" class="form-control" [(ngModel)]="reg.age" name="age"
                                        placeholder="{{'Age ' | translate }}">
                                    </div> -->

                        <div class="row my-0">
                          <div class="mb-3 form-group col-md-6">
                            <label class="col-form-label" for="gender" translate>Gender <span
                                style="color: red;">*</span></label>
                            <div class="input-group">
                              <ng-select class="input-group w-100" placeholder="Choose Gender..." aria-hidden="true"
                                [(ngModel)]="reg.gender" name="gender">
                                <ng-option [value]="'Male'">Male</ng-option>
                                <ng-option [value]="'Female'">Female</ng-option>
                                <!-- <ng-option [value]="'Others'">Others</ng-option> -->
                              </ng-select>
                            </div>
                          </div>

                          <div class="mb-3 form-group col-md-6">
                            <label class="col-form-label" for="countryId" translate> Nationality <span
                                style="color: red;">*</span></label>
                            <ng-select class="input-group w-100" placeholder="Choose Nationality..."
                              [(ngModel)]="reg.countryId" name="countryId" required>
                              <ng-option *ngFor="let d of countries" [value]="d.id">
                                {{d.nationality}}</ng-option>
                            </ng-select>
                            <!-- <input type="text" class="form-control" [(ngModel)]="reg.countryId" name="countryId"
                              placeholder="{{'Nationality' | translate }}"> -->
                            <!-- <div class="input-group">
  
                              <ng-select class="input-group w-100" placeholder="Choose nationality..." aria-hidden="true"
                                [(ngModel)]="reg.countryId" name="countryId">
                                <ng-option [value]="1">Ghanaian</ng-option>
                                <ng-option [value]="2">Nigerian</ng-option>
                              </ng-select>
                            </div> -->
                          </div>

                        </div>

                        <!-- <div class="mb-3 form-group col-md-6">
                          <label class="col-form-label" for="maritalStatus" translate>Marital Status <span
                              style="color: red;">*</span></label>
                          <div class="input-group">
                            <ng-select class="input-group w-100" placeholder="Choose Marital Status..."
                              aria-hidden="true" [(ngModel)]="reg.maritalStatus" name="maritalStatus">
                              <ng-option [value]="'Married'">Married</ng-option>
                              <ng-option [value]="'Single'">Single</ng-option>
                              <ng-option [value]="'Divorced'">Divorced</ng-option>
                            </ng-select>
                          </div>
                        </div> -->
                      </div>

                      <div class="row my-0">
                        <div class="mb-3 form-group col-md-6">
                          <label class="col-form-label dark" for="religiousAffiliation" translate>Religious Affiliation
                            <span style="color: red;">*</span></label>
                          <input class="form-control" type="text" [(ngModel)]="reg.religiousAffiliation"
                            name="religiousAffiliation" placeholder="{{'eg. Christian, Islam' | translate }}"
                            required />
                        </div>

                        <div class="mb-3 form-group col-md-6">
                          <label class="col-form-label" for="placeOfBirth" translate> Place Of Birth (Country) <span
                              style="color: red;">*</span></label>
                          <input type="text" class="form-control" [(ngModel)]="reg.placeOfBirth" name="placeOfBirth"
                            placeholder="{{'Place of Birth ' | translate }}">
                        </div>
                      </div>

                      <div class="row my-2">
                        <!-- <div class="mb-4 form-group col-md-12">
                          <label class="control-label dark" for="passportNumber" translate>Passport Number (If
                            International Student)</label>
                          <input type="text" class="form-control" [(ngModel)]="reg.passportNumber" name="passportNumber"
                            placeholder="{{'Passport Number ' | translate }}">
                        </div> -->
                        <div class="mb-3 form-group col-md-6">
                          <label class="control-label dark" for="languagesSpoken" translate>Language (s) Spoken</label>
                          <input type="text" class="form-control" [(ngModel)]="reg.languagesSpoken"
                            name="languagesSpoken" placeholder="{{'Languages Spoken ' | translate }}">
                        </div>

                        <div class="mb-3 form-group col-md-6">
                          <label class="control-label dark" for="favoriteSport" translate>Favourite
                            Sports/Games/Hobbies</label>
                          <input type="text" class="form-control" [(ngModel)]="reg.favoriteSport" name="favoriteSport"
                            placeholder="{{'Favourite Sports' | translate }}">
                        </div>


                        <div class="mb-0 form-group" style="position: relative;">
                          <label for="mobile">Primary Number
                            <span (click)="toggleTooltip()" style="cursor: pointer; position: relative;">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                fill="none">
                                <path
                                  d="M9 11.25C9 11.4478 8.94135 11.6411 8.83147 11.8056C8.72159 11.97 8.56541 12.0982 8.38269 12.1739C8.19996 12.2496 7.99889 12.2694 7.80491 12.2308C7.61093 12.1922 7.43275 12.097 7.2929 11.9571C7.15304 11.8173 7.0578 11.6391 7.01922 11.4451C6.98063 11.2511 7.00044 11.05 7.07612 10.8673C7.15181 10.6846 7.27998 10.5284 7.44443 10.4185C7.60888 10.3086 7.80222 10.25 8 10.25C8.26522 10.25 8.51957 10.3554 8.70711 10.5429C8.89465 10.7304 9 10.9848 9 11.25ZM14.75 8C14.75 9.33502 14.3541 10.6401 13.6124 11.7501C12.8707 12.8601 11.8165 13.7253 10.5831 14.2362C9.34971 14.7471 7.99252 14.8808 6.68314 14.6203C5.37377 14.3598 4.17104 13.717 3.22703 12.773C2.28303 11.829 1.64015 10.6262 1.3797 9.31686C1.11925 8.00749 1.25292 6.65029 1.76382 5.41689C2.27471 4.18349 3.13987 3.12928 4.2499 2.38758C5.35994 1.64588 6.66498 1.25 8 1.25C9.78961 1.25199 11.5053 1.96378 12.7708 3.22922C14.0362 4.49466 14.748 6.2104 14.75 8ZM13.25 8C13.25 6.96165 12.9421 5.94661 12.3652 5.08326C11.7883 4.2199 10.9684 3.54699 10.0091 3.14963C9.04978 2.75227 7.99418 2.6483 6.97578 2.85088C5.95738 3.05345 5.02192 3.55346 4.28769 4.28769C3.55347 5.02191 3.05345 5.95738 2.85088 6.97578C2.64831 7.99418 2.75228 9.04978 3.14964 10.0091C3.547 10.9684 4.2199 11.7883 5.08326 12.3652C5.94662 12.9421 6.96165 13.25 8 13.25C9.39193 13.2485 10.7264 12.6949 11.7107 11.7107C12.6949 10.7264 13.2485 9.39193 13.25 8ZM8 4C6.48375 4 5.25 5.12125 5.25 6.5V6.75C5.25 6.94891 5.32902 7.13968 5.46967 7.28033C5.61032 7.42098 5.80109 7.5 6 7.5C6.19892 7.5 6.38968 7.42098 6.53033 7.28033C6.67099 7.13968 6.75 6.94891 6.75 6.75V6.5C6.75 5.94875 7.3125 5.5 8 5.5C8.6875 5.5 9.25 5.94875 9.25 6.5C9.25 7.05125 8.6875 7.5 8 7.5C7.80109 7.5 7.61032 7.57902 7.46967 7.71967C7.32902 7.86032 7.25 8.05109 7.25 8.25V8.75C7.24956 8.9353 7.31772 9.1142 7.44135 9.25222C7.56498 9.39024 7.73533 9.47761 7.91956 9.49748C8.10378 9.51736 8.28885 9.46833 8.43907 9.35985C8.58929 9.25138 8.69404 9.09113 8.73313 8.91C9.89438 8.6175 10.75 7.64813 10.75 6.5C10.75 5.12125 9.51625 4 8 4Z"
                                  fill="#94A3B8" />
                              </svg>
                            </span>
                            <span style="color: red;">*</span>
                            <div *ngIf="tooltipVisible" class="tooltip">
                              Your tooltip text here.
                            </div>
                          </label>
                          <div class="form-group">
                            <ngx-intl-tel-input class="w-100" [cssClass]="'form-control custom'"
                              [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
                              [enablePlaceholder]="true" [searchCountryFlag]="true" [searchCountryField]="SearchCountry"
                              [selectFirstCountry]="true" [selectedCountryISO]="CountryISO.Ghana"
                              [phoneValidation]="true" [separateDialCode]="separateDialCode"
                              [numberFormat]="PhoneNumberFormat.National" [(ngModel)]="reg.mobile" name="reg.mobile"
                              required>
                            </ngx-intl-tel-input>
                          </div>
                        </div>

                        <div class="form-group col-md-6">
                          <label class="control-label dark" for="email" translate>Email <span
                              style="color: red;">*</span></label>
                          <input class="form-control" type="email" [(ngModel)]="reg.email" name="email"
                            placeholder="{{'Email' | translate }}" required />
                        </div>

                      </div>


                      <!-- <div class="row">
                        <div class="mb-0 form-group col-md-6">
                          <label for="emmergencyContact">Emergency Number <span style="color: red;">*</span></label>
                          <div class="form-group">
                            <ngx-intl-tel-input class="w-100" [cssClass]="'form-control custom'"
                              [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
                              [enablePlaceholder]="true" [searchCountryFlag]="true" [searchCountryField]="SearchCountry"
                              [selectFirstCountry]="true" [selectedCountryISO]="CountryISO.Ghana"
                              [phoneValidation]="true" [separateDialCode]="separateDialCode"
                              [numberFormat]="PhoneNumberFormat.National"[(ngModel)]="reg.emmergencyContact" name="reg.emmergencyContact" required>
                            </ngx-intl-tel-input>
                          </div>
                        </div>

                        <div class="mb-3 form-group col-md-6">
                          <label class="control-label dark" for="hobby" translate>Hobby </label>
                          <input type="text" class="form-control" [(ngModel)]="reg.hobby" name="hobby"
                            placeholder="{{'Hobby' | translate }}" required>
                        </div>


                      </div> -->

                      <!-- <div class="mb-3 form-group">
                        <label class="control-label dark" for="address">{{'ADDRESS' | translate }} <span
                            style="color: red;">*</span></label>
                        <textarea class="form-control" [(ngModel)]="reg.address" name="address" rows="3"
                          required></textarea>
                      </div> -->

                      <!-- <div>
                        <span class="dark">Hostel Required ? <span style="color: red;">*</span></span><br>
                        <label>
                          <input type="radio" name="hostel" [(ngModel)]="selectedOption" [value]="true" /> Yes
                        </label>
                      </div>
                      <div>
                        <label>
                          <input type="radio" name="hostel" [(ngModel)]="selectedOption" [value]="false" /> No
                        </label>
                      </div> -->

                      <div>
                      </div>

                      <!-- <br> -->

                      <!-- <div>
                        <div>
                          <span class="dark">Disability that require special attention ? <span
                              style="color: red;">*</span></span><br>
                          <label>
                            <input type="radio" name="disability" [(ngModel)]="selectedOption1" [value]="true" /> Yes
                          </label>
                        </div>
                        <div>
                          <label>
                            <input type="radio" name="disability" [(ngModel)]="selectedOption1" [value]="false" /> No
                          </label>
                        </div>
                      </div> -->
                      <br>

                      <!-- <div class="mb-3 form-group" *ngIf="this.selectedOption1 == true">
                        <label class="control-label dark" for="disabilityDesc" translate>If Yes</label>
                        <input type="text" class="form-control" [(ngModel)]="reg.disabilityDesc"
                          placeholder="if yes, state your reason" name="disabilityDesc">
                      </div> -->
                      <!-- <br /> -->
                      <button
                        [disabled]="!reg.firstName || !reg.lastName || !reg.photoUrl || !reg.dateOfBirth || !reg.gender || !reg.countryId || !reg.placeOfBirth || !previewUrl"
                        type="button" class="btn btn-danger float-right" awNextStep>Next Step</button>
                    </aw-wizard-step>
                    <aw-wizard-step stepTitle="Parents /Guardian Details" class="p-4">
                      <div class="row">
                        <div class="mb-4 form-group col-md-12">
                          <label class="control-label dark" for="lastName" translate>Name of Father <span
                              style="color: red;">*</span></label>
                          <input type="text" class="form-control" [(ngModel)]="father.name" name="father.name"
                            placeholder="{{'Name of Father ' | translate }}" required>
                        </div>
                        <div class="mb-4 form-group col-md-12">
                          <label class="control-label dark" for="firstName" translate>Father's Permanent Postal Address
                            <span style="color: red;">*</span></label>
                          <input type="text" class="form-control" [(ngModel)]="father.postalAddress"
                            name="father.postalAddress" placeholder="{{'Postal Address' | translate }}" required>
                        </div>
                        <div class="mb-3 form-group col-md-6">
                          <label class="col-form-label" for="nationality" translate>Father's Nationality <span
                              style="color: red;">*</span></label>
                          <ng-select class="input-group w-100" placeholder="Choose Nationality..."
                            [(ngModel)]="father.nationality" name="father.nationality" required>
                            <ng-option *ngFor="let d of countries" [value]="d.nationality">
                              {{d.nationality}}</ng-option>
                          </ng-select>
                          <!-- <input type="text" class="form-control" [(ngModel)]="father.nationality"
                            name="father.nationality" placeholder="{{'Nationality' | translate }}"> -->

                        </div>
                        <div class="mb-3 form-group col-md-6">
                          <label class="col-form-label" for="occupation" translate>Father's Present Occupation</label>
                          <input type="text" class="form-control" [(ngModel)]="father.occupation"
                            name="father.occupation" placeholder="{{'Occupation ' | translate }}">
                        </div>

                        <div class="mb-3 form-group col-md-6">
                          <label class="control-label dark" for="email" translate>Father's Email Address </label>
                          <input type="text" class="form-control" [(ngModel)]="father.email" name="father.email"
                            placeholder="{{'mailing Address ' | translate }}" required>
                        </div>
                        <div class="mb-0 form-group col-md-6">
                          <label for="mobile">Father's Mobile Number <span style="color: red;">*</span></label>
                          <div class="form-group">
                            <ngx-intl-tel-input class="w-100" [cssClass]="'form-control custom'"
                              [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
                              [enablePlaceholder]="true" [searchCountryFlag]="true" [searchCountryField]="SearchCountry"
                              [selectFirstCountry]="true" [selectedCountryISO]="CountryISO.Ghana"
                              [phoneValidation]="true" [separateDialCode]="separateDialCode"
                              [numberFormat]="PhoneNumberFormat.National" name="father.tempMobile"
                              [(ngModel)]="father.tempMobile" name="mobile" required>
                            </ngx-intl-tel-input>
                          </div>
                        </div>

                      </div>

                      <div>
                        <span class="dark">Father's Status ? <span style="color: red;">*</span></span><br>
                        <label>
                          <input type="radio" name="fstatus" [(ngModel)]="father.status" value="Alive" /> Alive
                        </label>
                      </div>
                      <div>
                        <label>
                          <input type="radio" name="fstatus" [(ngModel)]="father.status" value="Dead" /> Dead
                        </label>
                      </div>
                      <div class="row">
                        <div class="mb-4 form-group col-md-12">
                          <label class="control-label dark" for="lastName" translate>Name of Mother <span
                              style="color: red;">*</span></label>
                          <input type="text" class="form-control" [(ngModel)]="mother.name" name="mother.name"
                            placeholder="{{'Name of Mother ' | translate }}" required>
                        </div>
                        <div class="mb-4 form-group col-md-12">
                          <label class="control-label dark" for="firstName" translate>Mother's Permanent Postal Address
                            <span style="color: red;">*</span></label>
                          <input type="text" class="form-control" [(ngModel)]="mother.postalAddress"
                            name="mother.postalAddress" placeholder="{{'Postal Address' | translate }}" required>
                        </div>
                        <div class="mb-3 form-group col-md-6">
                          <label class="col-form-label" for="nationality" translate>Mother's Nationality <span
                              style="color: red;">*</span></label>
                          <ng-select class="input-group w-100" placeholder="Choose Nationality..."
                            [(ngModel)]="mother.nationality" name="mother.nationality" required>
                            <ng-option *ngFor="let d of countries" [value]="d.nationality">
                              {{d.nationality}}</ng-option>
                          </ng-select>
                          <!-- <input type="text" class="form-control" [(ngModel)]="mother.nationality"
                            name="mother.nationality" placeholder="{{'Nationality' | translate }}"> -->
                        </div>
                        <div class="mb-3 form-group col-md-6">
                          <label class="col-form-label" for="age" translate>Mother's Present Occupation</label>
                          <input type="text" class="form-control" [(ngModel)]="mother.occupation"
                            name="mother.occupation" placeholder="{{'Occupation ' | translate }}">
                        </div>

                        <div class="mb-3 form-group col-md-6">
                          <label class="control-label dark" for="email" translate>Mother's Email Address </label>
                          <input type="text" class="form-control" [(ngModel)]="mother.email" name="mother.email"
                            placeholder="{{'mailing Address ' | translate }}" required>
                        </div>
                        <div class="mb-0 form-group col-md-6">
                          <label for="mobile">Mother's Mobile Number <span style="color: red;">*</span></label>
                          <div class="form-group">
                            <ngx-intl-tel-input class="w-100" [cssClass]="'form-control custom'"
                              [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
                              [enablePlaceholder]="true" [searchCountryFlag]="true" [searchCountryField]="SearchCountry"
                              [selectFirstCountry]="true" [selectedCountryISO]="CountryISO.Ghana"
                              [phoneValidation]="true" [separateDialCode]="separateDialCode"
                              [numberFormat]="PhoneNumberFormat.National" name="mother.tempMobile"
                              [(ngModel)]="mother.tempMobile" name="mobile" required>
                            </ngx-intl-tel-input>
                          </div>
                        </div>

                      </div>

                      <div>
                        <span class="dark">Mother's Status ? <span style="color: red;">*</span></span><br>
                        <label>
                          <input type="radio" name="mstatus" [(ngModel)]="mother.status" value="Alive" /> Alive
                        </label>
                      </div>
                      <div>
                        <label>
                          <input type="radio" name="mstatus" [(ngModel)]="mother.status" value="Dead" /> Dead
                        </label>
                      </div>

                      <div class="row">
                        <div class="mb-4 form-group col-md-12">
                          <label class="control-label dark" for="lastName" translate>Full Name of Parent/Guardian
                            <span style="color: red;">*</span></label>
                          <input type="text" class="form-control" [(ngModel)]="guardian.name" name="guardian.name"
                            placeholder="{{'Name of Guardian ' | translate }}" required>
                        </div>
                        <div class="mb-4 form-group col-md-12">
                          <label class="control-label dark" for="firstName" translate>Relationship to Applicant
                            <span style="color: red;">*</span></label>
                          <input type="text" class="form-control" [(ngModel)]="guardian.note" name="guardian.note"
                            placeholder="{{'Relationship to Applicant' | translate }}" required>
                        </div>
                        <div class="mb-4 form-group col-md-12">
                          <label class="control-label dark" for="firstName" translate>Guardian's Permanent Postal
                            Address <span style="color: red;">*</span></label>
                          <input type="text" class="form-control" [(ngModel)]="guardian.postalAddress"
                            name="guardian.postalAddress" placeholder="{{'Postal Address' | translate }}" required>
                        </div>

                        <div class="mb-4 form-group col-md-12">
                          <label class="col-form-label" for="age" translate>Guardian's Residential Address
                          </label>
                          <input type="text" class="form-control" [(ngModel)]="guardian.address" name="guardian.address"
                            placeholder="{{'Residential Address ' | translate }}">
                        </div>

                        <div class="mb-3 form-group col-md-6">
                          <label class="control-label dark" for="mailingAddress" translate>Guardian's Email Address
                          </label>
                          <input type="text" class="form-control" [(ngModel)]="guardian.email" name="guardian.email"
                            placeholder="{{'mailing Address ' | translate }}" required>
                        </div>
                        <div class="mb-3 form-group col-md-6">
                          <label for="mobile">Guardian's Mobile Number <span style="color: red;">*</span></label>
                          <div class="form-group">
                            <ngx-intl-tel-input class="w-100" [cssClass]="'form-control custom'"
                              [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
                              [enablePlaceholder]="true" [searchCountryFlag]="true" [searchCountryField]="SearchCountry"
                              [selectFirstCountry]="true" [selectedCountryISO]="CountryISO.Ghana"
                              [phoneValidation]="true" [separateDialCode]="separateDialCode"
                              [numberFormat]="PhoneNumberFormat.National" [(ngModel)]="guardian.tempMobile"
                              name="guardian.tempMobile" required>
                            </ngx-intl-tel-input>
                          </div>
                        </div>

                      </div>

                      <br />
                      <button type="button" class="btn btn-danger" awPreviousStep>Go to previous step</button>
                      <button
                        [disabled]="!father.name || !father.postalAddress || !father.nationality || !father.tempMobile  || !mother.name || !mother.postalAddress || !mother.nationality || !mother.tempMobile  || !guardian.name || !guardian.postalAddress || !guardian.tempMobile"
                        type="button" class="btn btn-danger float-right" awNextStep>Next Step</button>
                    </aw-wizard-step>

                    <aw-wizard-step stepTitle="Last School Attended" class="p-4">
                      <div class="row">
                        <!-- <span class="btn btn-outline-danger col-3 mx-3" (click)="addInstitution()">Add more + </span> -->
                        <div class="col-md-12  border-bottom" *ngFor="let institution of institutions; let i = index;">
                          <div class="row mb-2 py-3">
                            <div class="mb-3 form-group col-md-6">
                              <label class="form-label" for="institution" translate>School Attended <span
                                  style="color: red;">*</span></label>
                              <input type="text" class="form-control" [(ngModel)]="institution.institutionName"
                                name="institutionName_{{institution.id}}" placeholder="School Attended" />
                            </div>
                            <div class="mb-3 form-group col-md-6">
                              <label class="form-label" for="certificate" translate>Certificate Obtained <span
                                  style="color: red;">*</span></label>
                              <input type="text" class="form-control" [(ngModel)]="institution.certificate"
                                name="certificate_{{institution.id}}" placeholder="certificate" />
                            </div>
                            <div class="mb-3 form-group col-md-12">
                              <label class="form-label" for="certificate" translate>Index Number<span
                                  style="color: red;">*</span></label>
                              <input type="text" class="form-control" [(ngModel)]="institution.indexNumber"
                                name="indexNumber_{{institution.id}}" placeholder="index Number" />
                            </div>
                            <div class="mb-3 form-group col-md-6">
                              <label class="control-label dark" for="dateAwarded" translate>Date Started <span
                                  style="color: red;">*</span></label>
                              <input type="month" class="form-control" [(ngModel)]="institution.dateStarted"
                                name="dateStarted_{{institution.id}}" placeholder="Date Started">
                            </div>
                            <div class="mb-3 form-group col-md-6">
                              <label class="control-label dark" for="dateAwarded" translate>Date Completed <span
                                  style="color: red;">*</span></label>
                              <input type="month" class="form-control" [(ngModel)]="institution.dateAwarded"
                                name="dateAwarded_{{institution.id}}" placeholder="Date Awarded">
                            </div>
                            <div class="mb-3 form-group col-md-6">
                              <label class="col-form-label" for="countryId" translate> Region <span
                                  style="color: red;">*</span></label>
                              <div class="input-group">
                                <ng-select class="input-group" placeholder="Choose Region..." aria-hidden="true"
                                  [(ngModel)]="institution.region" name="region_{{institution.id}}">
                                  <ng-option value="Central">Central</ng-option>
                                  <ng-option value="Eastern">Eastern</ng-option>
                                  <ng-option value="Western">Western</ng-option>
                                  <ng-option value="Northen">Northen</ng-option>
                                  <ng-option value="Ashanti">Ashanti</ng-option>
                                  <ng-option value="Brong Ahafo">Brong Ahafo</ng-option>
                                  <ng-option value="Greater Accra">Greater Accra</ng-option>
                                  <ng-option value="Bono East">Bono East</ng-option>
                                  <ng-option value="Upper East">Upper East</ng-option>
                                  <ng-option value="Upper West">Upper West</ng-option>
                                  <ng-option value="Volta">Volta</ng-option>
                                  <ng-option value="Savannah">Savannah</ng-option>
                                  <ng-option value="Oti">Oti</ng-option>
                                  <ng-option value="Ahafo">Ahafo</ng-option>
                                  <ng-option value="Western North">Western North</ng-option>
                                  <ng-option value="North East">North East</ng-option>
                                  <ng-option value="Africa">Africa</ng-option>
                                  <ng-option value="Europe">Europe</ng-option>
                                  <ng-option value="North America">North America</ng-option>
                                  <ng-option value="Australia">Australia</ng-option>
                                  <ng-option value="South America">South America</ng-option>
                                  <ng-option value="Asia">Asia</ng-option>
                                </ng-select>
                              </div>
                            </div>
                            <div class="mb-3 form-group col-md-6">
                              <label class="control-label dark" for="indexNumber" translate>Location of School <span
                                  style="color: red;">*</span></label>
                              <input type="text" class="form-control" [(ngModel)]="institution.location"
                                name="location_{{institution.id}}" placeholder="eg: Madina, Accra" required>
                            </div>
                          </div>
                          <!-- <button type="button" class="btn btn-outline-danger col-3 mb-3"
                            (click)="removeInstitution(i)">Remove</button> -->
                        </div>
                        <div class="mt-4">
                          <button type="button" class="btn btn-danger" awPreviousStep>Go to previous step</button>
                          <button type="button" class="btn btn-danger float-right" (click)="logValue()" awNextStep>Next
                            Step</button>
                        </div>
                      </div>


                    </aw-wizard-step>

                    <aw-wizard-step stepTitle="Enrollment Information" class="p-4">

                      <!-- need -->
                      <div class="row">
                        <div>
                          <span class="dark" translate>Do you have normal Health ? <span
                              style="color: red;">*</span></span>
                          <div class="form-check">
                            <label>
                              <input type="radio" name="hasNormalHealth" [(ngModel)]="reg.hasNormalHealth"
                                value="true" />
                              Yes
                            </label>
                          </div>
                          <div class="form-check">
                            <label>
                              <input type="radio" name="hasNormalHealth" [(ngModel)]="reg.hasNormalHealth"
                                value="false" /> No
                            </label>
                          </div>
                        </div>
                        <div>
                          <span class="dark" translate>Is the applicant's hearing normal? <span
                              style="color: red;">*</span></span>

                          <div class="form-check">
                            <label>
                              <input type="radio" name="hasNormalHearing" [(ngModel)]="reg.hasNormalHearing"
                                value="true" /> Yes
                            </label>
                          </div>
                          <div class="form-check">
                            <label>
                              <input type="radio" name="hasNormalHearing" [(ngModel)]="reg.hasNormalHearing"
                                value="false" /> No
                            </label>
                          </div>
                        </div>
                        <!-- <div>
                                      <span class="dark" translate>Does the applicant have any permanent disability ?<span style="color: red;">*</span></span>
                                      <div class="form-check">
                                        <input class="form-check-input" type="radio" name="disability" [(ngModel)]="reg.disability"
                                          id="exampleRadios1" value="true">
                                        <label class="form-check-label" for="exampleRadios1">
                                          Yes
                                        </label>
                                      </div>
                                      <div class="form-check">
                                        <input class="form-check-input" type="radio" name="disability" [(ngModel)]="reg.disability"
                                          id="exampleRadios2" value="false">
                                        <label class="form-check-label" for="exampleRadios2">
                                          No
                                        </label>
                                      </div>
                                    </div> -->
                        <div>
                          <span class="dark" translate>Is the applicant's eye sight normal ?<span
                              style="color: red;">*</span></span>
                          <div class="form-check">
                            <label>
                              <input type="radio" name="hasNormalEyesight" [(ngModel)]="reg.hasNormalEyesight"
                                value="true" /> Yes
                            </label>
                          </div>
                          <div class="form-check">
                            <label>
                              <input type="radio" name="hasNormalEyesight" [(ngModel)]="reg.hasNormalEyesight"
                                value="false" /> No
                            </label>
                          </div>
                        </div>
                        <div class="mb-4 form-group col-md-12">
                          <label class="col-form-label" for="healthRelatedInfo">{{'Provide any other important health
                            related information ' | translate}} </label>
                          <input type="text" class="form-control" name="reg.healthRelatedInfo"
                            [(ngModel)]="reg.healthRelatedInfo" placeholder="Health Conditions" required>
                        </div>

                        <div class="mb-4 form-group col-md-12">
                          <div class="alert alert-info d-flex align-items-start gap-3 p-3 rounded shadow-sm mt-4" role="alert">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-info-circle text-primary mt-1 flex-shrink-0" viewBox="0 0 16 16">
                              <path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zm0 13A6 6 0 1 1 8 2a6 6 0 0 1 0 12z"/>
                              <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 .875-.252 1.02-.598l.088-.416c.066-.308.12-.438.432-.495l.451-.083.082-.38-1.993-.287-.088-.416c-.066-.308-.12-.438-.432-.495zm-.93-2.588a.905.905 0 1 1 0 1.81.905.905 0 0 1 0-1.81z"/>
                            </svg>
                            <div>
                              <p class="mb-0">
                                Kindly read the subject combinations of the various programmes on the admissions portal of the school website before making a choice
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="mb-4 form-group col-md-12">
                          <label class="col-form-label" for="courseId">{{'First Programme Choice' | translate}} <span
                              style="color: red;">*</span></label>
                          <div class="input-group">
                            <ng-select class="input-group w-100" placeholder="Choose Course..."
                              [(ngModel)]="selectedCourse" name="selectedCourse" (change)="onCourseChange($event)"
                              required>
                              <ng-option *ngFor="let d of courses" [value]="d">{{d.name}} </ng-option>
                            </ng-select>

                          </div>
                        </div>

                        <div class="mb-4 form-group col-md-12">
                          <label class="col-form-label" for="secondCourseId">{{'Second Programme Choice' | translate}}
                            <span style="color: red;">*</span></label>
                          <div class="input-group">
                            <ng-select class="input-group w-100" placeholder="Choose Course..."
                              [(ngModel)]="reg.secondCourseId" name="secondCourseId" required>
                              <ng-option *ngFor="let d of courses" [value]="d.id">{{d.name}} </ng-option>
                            </ng-select>
                          </div>
                        </div>
                        <div>
                          <span class="dark" translate>Date for entrance examination<span
                              style="color: red;">*</span></span>
                          <div class="form-check">
                            <label>
                              <input type="radio" name="dateForExam" [(ngModel)]="reg.dateForExam"
                                value="Saturday, June 21, 2025" /> Saturday, June 21, 2025
                            </label>

                          </div>

                          <div class="form-check">
                            <div>
                              <label>
                                <input type="radio" name="dateForExam" [(ngModel)]="reg.dateForExam"
                                  value="Saturday, June 28, 2025" /> Saturday, June 28, 2025
                              </label>
                            </div>
                          </div>

                          <div class="form-check">
                            <div>
                              <label>
                                <input type="radio" name="dateForExam" [(ngModel)]="reg.dateForExam"
                                  value="Saturday, July 5, 2025" /> Saturday, July 5, 2025
                              </label>
                            </div>
                          </div>

                        </div>
                        <div>
                          <span class="dark" translate>Venue for entrance examination<span
                              style="color: red;">*</span></span>
                          <div class="form-check">

                            <label>
                              <input type="radio" name="venueForExam" [(ngModel)]="reg.venueForExam"
                                value="Hope College Campus, Gomoa-Fetteh (Central Region)">
                              Hope College Campus, Gomoa-Fetteh (Central Region)
                            </label>
                          </div>

                          <div class="form-check">

                            <label>
                              <input type="radio" name="venueForExam" [(ngModel)]="reg.venueForExam"
                                value="Knutsford University, East Legon - Accra (Greater Accra Region)">
                              Knutsford University, East Legon - Accra (Greater Accra Region)
                            </label>
                          </div>

                          <div class="form-check">
                            <label>
                              <input type="radio" name="venueForExam" [(ngModel)]="reg.venueForExam"
                                value="Christian Vertical Centre School - Tema Community 6 (Greater Accra Region)">
                              Christian Vertical Centre School - Tema Community 6 (Greater Accra Region)
                            </label>
                          </div>

                          <div class="form-check">
                            <label>
                              <input type="radio" name="venueForExam" [(ngModel)]="reg.venueForExam"
                                value="Machris Academy - Tarkwa (Western Region)">
                              Machris Academy - Tarkwa (Western Region)
                            </label>
                          </div>

                          <div class="form-check">
                            <label>
                              <input type="radio" name="venueForExam" [(ngModel)]="reg.venueForExam"
                                value="Ghana Bible College - Bunso, Kumasi (Ashanti Region)">
                              Ghana Bible College - Bunso, Kumasi (Ashanti Region)
                            </label>
                          </div>

                        </div>
                        <div><br>
                          <h6>How did you hear about Hope College <span style="color: red;">*</span></h6>

                          <div class="mb-3">
                            <div class="form-check">
                              <input type="radio" name="referralSource" [(ngModel)]="reg.referralSource"
                                value="Church Announcement ">
                              <label class="form-check-label" for="WASSCE">
                                Church Announcement
                              </label>
                            </div>
                            <div class="form-check">
                              <input type="radio" name="referralSource" [(ngModel)]="reg.referralSource"
                                value="Announcement in your school/your child's school">
                              <label class="form-check-label" for="City">
                                Announcement in your school/your child's school
                              </label>
                            </div>
                            <div class="form-check">
                              <input type="radio" name="referralSource" [(ngModel)]="reg.referralSource"
                                value="From a parent of a student / From a parent of an old student">
                              <label class="form-check-label" for="Transfer">
                                From a parent of a student / From a parent of an old student
                              </label>
                            </div>
                            <div class="form-check">
                              <input type="radio" name="referralSource" [(ngModel)]="reg.referralSource"
                                value="From an old student of Hope College">
                              <label class="form-check-label" for="NAPTEX">
                                From an old student of Hope College
                              </label>
                            </div>
                            <div class="form-check">
                              <input type="radio" name="referralSource" [(ngModel)]="reg.referralSource"
                                value="Bill Board advertisement">
                              <label class="form-check-label" for="SSSCE">
                                Bill Board advertisement
                              </label>
                            </div>
                            <div class="form-check">
                              <input type="radio" name="referralSource" [(ngModel)]="reg.referralSource"
                                value="Radio advertisement">
                              <label class="form-check-label" for="International">
                                Radio advertisement
                              </label>
                            </div>
                            <div class="form-check">
                              <input type="radio" name="referralSource" [(ngModel)]="reg.referralSource"
                                value="Hope College Website ">
                              <label class="form-check-label" for="Baccalaureate">
                                Hope College Website
                              </label>
                            </div>
                            <div class="form-check">
                              <input type="radio" name="referralSource" [(ngModel)]="reg.referralSource"
                                value="Televison">
                              <label class="form-check-label" for="Televison">
                                Televison
                              </label>
                            </div>
                          <div class="form-check">
                            <input type="radio" name="referralSource" [(ngModel)]="reg.referralSource"
                              value="SMS Alert">
                            <label class="form-check-label" for="ABCE">
                              SMS Alert
                            </label>
                          </div>
                          <div class="form-check">
                            <input type="radio" name="referralSource" [(ngModel)]="reg.referralSource" value="Other">
                            <label class="form-check-label" for="Other">
                              Other
                            </label>
                          </div>
                        </div>
                      </div>

                      <div class="mb-4 form-group col-md-12" *ngIf="reg.referralSource == 'Other'">
                        <label class="control-label dark" for="referralSource" translate>Please provide further details
                          if you chose "other"
                        </label>
                        <input type="text" class="form-control" name="referralSourceOther" placeholder="Other"
                          [(ngModel)]="reg.referralSourceOther">
                      </div>

                      <div>
                        <span class="dark" translate>Please were you referred to Hope College by any person?
                          <span style="color: red;">*</span></span>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="disability" id="exampleRadios1"
                            value="True">
                          <label class="form-check-label" for="exampleRadios1">
                            Yes
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="disability" id="exampleRadios2"
                            value="False">
                          <label class="form-check-label" for="exampleRadios2">
                            No
                          </label>
                        </div>
                      </div>

                      <div class="mb-4 form-group col-md-12">
                        <label class="control-label dark" for="indexNumber" translate>Please if your answer to the
                          previous question was "Yes, " kindly indicate the name and telephone number of the one who
                          referred you.
                        </label>
                        <input type="text" class="form-control" placeholder="Other" [(ngModel)]="reg.notes">
                      </div>


              </div>

              <button type="button" class="btn btn-danger" awPreviousStep>Go to previous step</button>
              <button
                [disabled]="!selectedCourse  || !reg.secondCourseId || !dateForExam || !venueForExam || !reg.referralSource"
                class="btn btn-danger float-right mb-3" type="submit"><span *ngIf="submitted == false">
                  {{'COMPLETE_REG' | translate}}</span> <span class="disabled" *ngIf="submitted == true">please
                  wait <i class="fas fa-spinner fa-spin"></i> </span> </button>
              </aw-wizard-step>
              </aw-wizard>

              </form>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>